module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/banner/zh-hans-88a7a7c0a156f855372299c08eee6d3d.jpg";